import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Uno = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Problem</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>
          <ul>
            <li>In Mexico City we discovered that <b>aging population will continue to increase [2].</b></li>
            <li><b>Aging-associated diseases are not being effectively diagnosed to  prevent deadly diseases</b> and the incidence of all of these diseases increases exponentially with age [3].</li>
            <li>A recent study by the National Institute of Geriatrics in Mexico found that <b>70% of older adults do not receive the medical services needed [4].</b></li>
            <li>It is reported that <b>there is only one trained geriatrician for every 22,000 seniors in Mexico,</b> which compares poorly to the 1 trained geriatrician for every 8,500 seniors in the UK [5].</li>
            <li>One of the hallmarks of aging is a gradual increase in levels of chronic low-grade inflammation. By misdiagnosing this, whether overdiagnosis or underdiagnosis,<b> it exposes older patients to increased risk of inappropriate or missed investigations and treatments, psychological distress, and financial burden.</b> (Check Project Description Section).</li>
          </ul>
        </Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-24.jpg'/>
          <p><b>Fig. 6.1</b> Complementary image of the <q>Problem</q> section in the Business Model Canva. Elder people in Mexico are exposed to inappropriate  diagnosis.</p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Uno;
